/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SpoEditPageComponent} from './spo-edit-page.component';
import {SingleMaterialStatusModule} from '../../shared/single-material-status/single-material-status.module';
import {SpoSharedModule} from '../shared/spo-shared.module';
import {NgbDatepickerModule, NgbDropdownModule, NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import {ReactiveFormsModule} from '@angular/forms';
import {MaterialListModule} from '../../shared/material-list/material-list.module';
import {SpoDetailModule} from '../../shared/spo-detail/spo-detail.module';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';

@NgModule({
    declarations: [
        SpoEditPageComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        NgbTypeaheadModule,
        NgbDatepickerModule,
        SpoSharedModule,
        SpoDetailModule,
        SingleMaterialStatusModule,
        MaterialListModule,
        NgbDropdownModule,
        LoadingSpinnerModule
    ],
    exports: [SpoEditPageComponent]
})

export class SpoEditPageModule {
}
